<template>
  <main class="m">
      <div class="container">
          <router-view/>
      </div>
  </main>
</template>

<script>
export default {
  name: 'Main'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.m
  flex: 1 0 auto  
</style>

